import { SettingsSection } from '@components'

import { Button } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { ZervantSubscription } from '@features/zervant-subscription/query-api'

import { SummaryBoxesComponent } from '../../SummaryBoxesComponent'

interface StripePortalPaymentSectionProps {
  zervantSubscription: ZervantSubscription | undefined
  isOpeningPortal: boolean
  onChangePayment: () => void
}

export const StripePortalPaymentSection = ({
  zervantSubscription,
  isOpeningPortal,
  onChangePayment,
}: StripePortalPaymentSectionProps): ReactElement => {
  const { t } = useTranslation()

  const card = zervantSubscription?.payment?.card ?? null

  const paymentSummaryItems = useMemo(() => {
    if (!card) {
      return []
    }
    const brand = `${card.brand.charAt(0).toUpperCase()}${card.brand.slice(1)}`
    return [
      { name: t('organization_subscription.stripe_portal.card'), value: `${brand} ••••${card.last4}` },
      { name: t('organization_subscription.stripe_portal.expires'), value: card.expiry },
    ]
  }, [card, t])

  return (
    <SettingsSection>
      <SettingsSection.RowsContainer>
        <SettingsSection.Content
          title={t('organization_subscription.payment_methods')}
          sideActions={
            card ? (
              <Button loading={isOpeningPortal} onClick={onChangePayment} icon="squarePen" variant="outlined">
                {t('organization_subscription.stripe_portal.change_payment_button')}
              </Button>
            ) : undefined
          }
        >
          {card ? (
            <SummaryBoxesComponent items={paymentSummaryItems} />
          ) : (
            <Button loading={isOpeningPortal} onClick={onChangePayment} variant="outlined">
              {t('organization_subscription.add_payment_method')}
            </Button>
          )}
        </SettingsSection.Content>
      </SettingsSection.RowsContainer>
    </SettingsSection>
  )
}
